import { safeDefine } from "../../registration/safe-define.js";
import { SliderThumbnailElement } from "../../ui/slider/thumbnail.js";
//#region src/define/ui/slider-thumbnail.ts
safeDefine(SliderThumbnailElement);
//#endregion

//# sourceMappingURL=slider-thumbnail.js.map